import { put, call, takeLatest, all } from 'redux-saga/effects';

import { authLogin, getCurrentUser } from 'api/auth';
import { AUTH_ACTION_TYPES, setAuthInfo } from 'store/actions/auth.actions';
import { AUTH_TOKEN, REFRESH_TOKEN, writeToLocalState, clearLocalState } from 'utils/localStorage';

function* loginFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data: { token, refresh_token: refreshToken } } = yield authLogin(payload);
    yield put(setAuthInfo({ token, refreshToken }));
    resolve();
  } catch (e) {
    reject(e);
  }
}

function* logoutFlow() {
  clearLocalState(AUTH_TOKEN);
}

function* setAuthInfoFlow(action) {
  writeToLocalState(AUTH_TOKEN, action.payload.token);
  if (action.payload.refreshToken) {
    writeToLocalState(REFRESH_TOKEN, action.payload.refreshToken);
  }
}

function* getCurrentFlow(action) {
  const { resolve, reject } = action;
  try {
    const { data: response } = yield call(getCurrentUser);
    resolve(response);
  } catch (e) {
    reject(e);
  }
}

function* watchLogin() {
  yield takeLatest(AUTH_ACTION_TYPES.LOGIN, loginFlow);
}

function* watchLogout() {
  yield takeLatest(AUTH_ACTION_TYPES.LOGOUT, logoutFlow);
}

function* watchSetAuthInfo() {
  yield takeLatest(AUTH_ACTION_TYPES.SET_AUTH_INFO, setAuthInfoFlow);
}

function* watchGetCurrent() {
  yield takeLatest(AUTH_ACTION_TYPES.GET_CURRENT, getCurrentFlow);
}

export default function* () {
  yield all([watchLogin(), watchLogout(), watchSetAuthInfo(), watchGetCurrent()]);
}
